


















































































































import { ActivitySession } from '@activities/interfaces/activity-session';
import { ContactAttendeeInformation } from '@activities/interfaces/activity-session-attendee';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-add-attendees-step',
  components: {},
})
export default class SelectAttendeesStep extends Vue {
  // PROPS
  // @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  // @Prop({ type: Boolean, default: false }) readonly savingAttendes: boolean;
  @Prop({ type: Number }) readonly sessionId: number;
  @Prop({ type: Number }) readonly contactId: number;
  @Prop({ type: Boolean }) readonly disabled: boolean;
  @Prop({
    type: Number,
    default() {
      return null;
    },
  })
  readonly value: number;

  // DATA
  loadingUserInfo = false;
  session: ActivitySession = null;
  contactAttendeesInformation: ContactAttendeeInformation[] = [];
  // COMPUTED
  get currentContactInformation(): ContactAttendeeInformation {
    return (this.contactAttendeesInformation || []).find(contactAttendeeInfo => {
      return contactAttendeeInfo.contact_id === this.selectedContactId;
    });
  }
  get showContactSelector(): boolean {
    return (
      (this.contactAttendeesInformation && this.contactAttendeesInformation.length > 1) ||
      (this.currentContactInformation && !this.currentContactInformation.contact_is_allowed_attend)
    );
  }
  get selectedContactId(): number {
    return this.value;
  }

  set selectedContactId(value) {
    this.$emit('input', value);
  }

  get limitedAttendeeSession(): boolean {
    if (!this.session) {
      return false;
    }
    return !!this.session.max_participants;
  }
  get remainingParticipants(): number {
    if (this.limitedAttendeeSession) {
      const limitReached = this.session.max_participants <= this.session.num_attendees;

      return limitReached ? 0 : this.session.max_participants - this.session.num_attendees;
    }

    return 0;
  }

  get waitingListIsOpen(): boolean {
    return this.session.with_waiting_list;
  }

  // LIFECYCLE
  async mounted() {
    await this.getUserSessionInfo();
  }

  disableForThisContact(contactAttendeeInformation: ContactAttendeeInformation): boolean {
    return (
      !contactAttendeeInformation.session_allowed_to_be_attended &&
      (!this.session.with_waiting_list || contactAttendeeInformation.contact_is_attendee)
    );
  }

  async getUserSessionInfo() {
    this.loadingUserInfo = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const path = `${basePath}/${this.sessionId}/contact-information/${this.contactId}`;
    const res = await this.$bpcApi.get(path, null, 'admin').toPromise();
    this.session = res.data.session;
    this.contactAttendeesInformation = res.data.contactAttendeesInformation;
    this.selectCurrentContactIfAllowed();
    this.loadingUserInfo = false;
    this.$emit('contacts-info-loaded', true);
  }

  selectCurrentContactIfAllowed() {
    const contactInformation = (this.contactAttendeesInformation || []).find(
      contactAttendeeInfo => {
        return contactAttendeeInfo.contact_id === this.contactId;
      },
    );
    if (contactInformation) {
      if (contactInformation.contact_is_allowed_attend) {
        this.selectedContactId = this.contactId;
      }
    }
  }

  continuePaymentProcess(contactAttendeeInformation: ContactAttendeeInformation) {
    this.$emit('continue-payment-clicked', { session: this.session, contactAttendeeInformation });
  }

  onAddFamilyMember() {
    this.$emit('add-family-member-clicked');
  }

  // METHODS

  // WATCHERS
}
